/**
 * Centralized currency formatting for the Fitvent platform.
 * All price display should use these helpers instead of hardcoding €.
 */

const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '€',
  GBP: '£',
  USD: '$',
};

export function getCurrencySymbol(currency?: string | null): string {
  return CURRENCY_SYMBOLS[(currency || 'EUR').toUpperCase()] || '€';
}

/** Format a price in major units (e.g. 29.99) with the correct currency symbol. */
export function formatPrice(amount: number, currency?: string | null): string {
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${amount.toFixed(2)}`;
}

/** Format a price stored in cents (e.g. 2999) with the correct currency symbol. */
export function formatPriceCents(cents: number, currency?: string | null): string {
  return formatPrice(cents / 100, currency);
}
